import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'round',
  standalone: true
})
export class RoundPipe implements PipeTransform {
  transform(value: number, decimals: number = 2): number | null {
    if (value === null || value === undefined || isNaN(value)) {
      return null;
    }
    return parseFloat(value.toFixed(decimals));
  }
}
